import { Component, OnInit } from '@angular/core';
import { SnapshotStatus } from '../../enums/snapshot.enum';
import { ExportSnapshotResultsService } from '../../services/export-snapshot-results.service';
import { SnapshotService } from '../../services/snapshot.service';
import { SnapshotMainComponentElementList } from '../../models/snapshot.interface';

@Component({
	selector: 'vtr-snapshot-main',
	templateUrl: './snapshot-main.component.html',
	styleUrls: ['./snapshot-main.component.scss'],
})
export class SnapshotMainComponent implements OnInit {
	public softwareComponents: Array<SnapshotMainComponentElementList>;
	public hardwareComponents: Array<SnapshotMainComponentElementList>;

	constructor(
		private snapshotService: SnapshotService,
		private exportSnapshotService: ExportSnapshotResultsService
	) {
		this.softwareComponents = [];
		this.hardwareComponents = [];
	}

	ngOnInit(): void {
		this.snapshotService.getSoftwareComponentsList().forEach((key) => {
			this.softwareComponents.push({
				name: key,
				content: this.snapshotService.snapshotInfo[key],
			});
		});

		this.snapshotService.getHardwareComponentsList().forEach((key) => {
			this.hardwareComponents.push({
				name: key,
				content: this.snapshotService.snapshotInfo[key],
			});
		});
	}

	public exportLog() {
		this.exportSnapshotService.exportSnapshotResults();
	}

	public getExportIcon(isDisabled: boolean): string {
		return this.exportSnapshotService.getExportIcon(isDisabled);
	}

	public isButtonEnabled(): boolean {
		const statesToEnable = [
			SnapshotStatus.notStarted,
			SnapshotStatus.snapshotCompleted,
			SnapshotStatus.baselineCompleted,
		];
		return statesToEnable.includes(this.snapshotService.snapshotStatus);
	}
}
